/**
 * Links that only bring a Mac app forward, for the on-device setup cards.
 * OmniFocus rejects a link with no path, so its link opens the Inbox.
 * Matched exactly because the same schemes also take commands, such as
 * `things:///add`.
 */
export const APP_LAUNCH_URLS: ReadonlySet<string> = new Set([
  'things:///',
  'x-fantastical3://',
  'omnifocus:///inbox',
  'messages://',
]);
